// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './components/MyteGroupWebsite/HomePage';
import VideosPage from './components/MyteGroupWebsite/VideosPage'; // <-- import new page
import AboutPage from './components/MyteGroupWebsite/AboutPage';
import MyteAITrainingCourses from './components/MyteGroupWebsite/MyteAITrainingCourses';

import SphereFlow from './components/SubscriptionFunnel/SphereFlow';
import TimesheetsPage from './components/TimeSheets/TimesheetsPage';
import BusinessCardsPage from './components/BusinessCardFlow/BusinessCardsPage';
import EquipmentRequestPage from './components/EquipmentRequest/EquipmentRequestPage';
import CooperDashboard from './components/EquipmentRequest/CooperDashboard';
import MyteConstructionApp from './components/myteconstruction/MyteConstructionApp';

// Our Auth Provider
import { AuthProvider } from './context/AuthContext';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import Modal from 'react-modal';

Modal.setAppElement('#root');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Wrap entire app in AuthProvider */}
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/videos" element={<VideosPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/joinMyte/*" element={<SphereFlow />} />
          <Route path="/MyteAITrainingCourses" element={<MyteAITrainingCourses />} />

          {/* Tools */}
          <Route path="/timesheets" element={<TimesheetsPage />} />
          <Route path="/business-cards" element={<BusinessCardsPage />} />
          <Route path="/equipment-request" element={<EquipmentRequestPage />} />
          <Route path="/cooperdashboard" element={<CooperDashboard />} />

          {/* Myte Construction Application Routes */}
          <Route path="/myteconstruction/*" element={<MyteConstructionApp />} />

        </Routes>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);

serviceWorkerRegistration.register();
reportWebVitals();
